import React from "react";

const Terms = () => {
  const paragraph = [
    {
      paragraph:
        'These Terms of Use ("Terms") govern your access to and use of the applications, websites—including UTIRX.com—content, products, and services (collectively, the "Services") made available by UTIRX.com, LLC, together with its parents, subsidiaries, representatives, affiliates, officers, and directors (collectively, "UTIRX.com," "we," or "us"). PLEASE READ THESE TERMS CAREFULLY, AS THEY CONSTITUTE A LEGALLY BINDING AGREEMENT BETWEEN YOU AND UTIRX.com.\n',
    },
    {
      paragraph:
        "By accessing or using the Services, you confirm that you have read, understood, and agree to be bound by these Terms as well as our Privacy Policy. Supplemental terms may apply to particular Services (for example, promotional programs, events, or additional policies). Any supplemental terms are in addition to, and form a part of, these Terms; where a conflict exists, the supplemental terms control for the relevant Service(s). If you do not agree to these Terms, you must not access or use the Services. These Terms expressly supersede all prior agreements or arrangements between you and UTIRX.com. We may terminate these Terms—or any Services offered to you—and/or deny your access to any portion of the Services at any time and for any reason permitted by law.\n",
    },

    {
      paragraph: (
        <b>
          IMPORTANT ARBITRATION NOTICE THESE TERMS CONTAIN AN ARBITRATION
          AGREEMENT WHICH, WITH LIMITED EXCEPTIONS, REQUIRES YOU TO RESOLVE
          DISPUTES WITH UTIRX.COM THROUGH FINAL AND BINDING INDIVIDUAL
          ARBITRATION AND NOT BY A JURY TRIAL OR CLASS ACTION. PLEASE SEE THE
          “ARBITRATION AGREEMENT” SECTION BELOW.
        </b>
      ),
    },
    {
      paragraph:
        "If your use of the Services is terminated for any reason: (i) these Terms will continue to apply to your prior use of the Services (and to any unauthorized further use), including your indemnification obligations; and (ii) any licenses granted to UTIRX.com under these Terms will survive such termination.UTIRX.com may modify these Terms from time to time. Your continued access or use of the Services after the effective date of any updated Terms constitutes acceptance of those updated Terms.\n",
    },
  ];
  const paragraph2 = [
    {
      paragraph: (
        <>
          By agreeing to these Terms, you agree that all disputes and claims
          between you and UTIRX.com will be resolved exclusively through
          binding, individual arbitration, except where otherwise provided
          herein. This agreement limits your rights to litigate disputes in
          court, to have a jury trial, and to participate in class actions.
          <ol>
            <li>
              Scope. The arbitration requirement applies to any claim, dispute,
              or controversy—whether under contract, tort, statute, or
              otherwise— arising from or relating to these Terms or your access
              to or use of the Services, whether the dispute arose before or
              after you accepted these Terms.
            </li>
            <li>
              Rules & Governing Law. Arbitration will be administered by the
              American Arbitration Association ("AAA") under its Consumer
              Arbitration Rules (the "AAA Rules") as modified by this section.
              The AAA Rules are available at www.adr.org or by calling
              800-778-7879. The Federal Arbitration Act ("FAA") governs the
              interpretation and enforcement of this Arbitration Agreement.
            </li>
            <li>
              Process. To initiate arbitration, a party must provide the other
              party with a written Demand for Arbitration as specified in the
              AAA Rules. The Arbitrator will be a retired judge or attorney
              licensed in the state of Florida, unless the parties agree
              otherwise.
            </li>
            <li>
              Location & Procedure. Unless the parties agree otherwise,
              arbitration will occur in the county where you reside. If your
              claim does not exceed $10,000, the arbitration will be conducted
              solely on documents unless you request a hearing or the Arbitrator
              requires one.
            </li>
            <li>
              Arbitrator’s Decision. The Arbitrator’s decision is final and
              binding and judgment may be entered in any court of competent
              jurisdiction. The Arbitrator may award declaratory or injunctive
              relief only to the extent necessary to provide relief warranted by
              the claimant’s individual claim.
            </li>
            <li>
              Fees. Arbitration fees will be allocated as provided in the AAA
              Rules.
            </li>
            <li>
              Severability. If any part of this Arbitration Agreement is found
              unenforceable, the remainder will remain in effect, except that
              any claim that must proceed on a class-wide basis must be
              litigated in court and not in arbitration.
            </li>
          </ol>
        </>
      ),
    },
  ];
  const paragraph3 = [
    {
      paragraph: (
        <>
          2.1 Fees & Payment <br />
          UTIRX.com is a telemedicine service that puts you in touch with
          medical providers through the limited scope of the intake form on the
          website. In addition to the telemedicine service costs charged on
          UTIRX.com, you are responsible for the cost of the actual medication
          when it is picked up from the pharmacy at the time of purchase.
          UTIRX.com does not make payments to any pharmacy or communicate with
          any insurance companies. Payments for services made to UTIRX.com may
          not be covered by your health insurance, count toward your insurance
          out-of-pocket maximums, or be reimbursable; confirm with your carrier.
        </>
      ),
    },

    {
      paragraph: (
        <>
          2.2 Telehealth Services <br />
          UTIRX.com provides an online communication platform that connects you
          with physicians and other healthcare professionals (each, a
          "Provider") employed by or contracted with an independent professional
          corporation or professional limited liability company (collectively,
          the "Medical Group"). The clinical services provided by the Medical
          Group plus our non-clinical platform services are together called the
          "Telehealth Services". Providers prescribe medications only if
          clinically appropriate and in compliance with applicable law; no
          guarantee is made that a prescription will be issued. Providers do not
          prescribe DEA-controlled substances or other medications prone to
          misuse. You agree that any prescription you receive is for your
          personal use and that you will read all accompanying information
          before use.
          <br />
          <br />
          You acknowledge and understand that the issuance of a prescription, if
          deemed medically appropriate, does not guarantee the resolution or
          improvement of your symptoms or medical condition. Treatment outcomes
          vary among individuals, and no representation or warranty is made
          regarding the effectiveness of any prescribed medication.
          <br />
          <br />
          You agree to promptly seek further medical evaluation from your
          primary care provider, an urgent care center, or an emergency
          department, as appropriate, if your symptoms persist, worsen, fail to
          improve, or if you experience any adverse reaction, allergic reaction,
          new symptoms, or other concerning changes in your condition. You
          understand that it is your responsibility to obtain appropriate
          follow-up care and that this service is not a substitute for ongoing
          medical management. Telehealth Services are not for emergencies. If
          you think you have a medical emergency, call 9-1-1 immediately.
          Telehealth Services may not
          be available in all states. By using the Services, you represent that
          you are located in a U.S. state where we operate and are not barred
          from enrolling for (or receiving) the Telehealth Services under U.S.
          law. UTIRX.com and the Medical Group are not insurers; payments you
          make are not insurance premiums.
        </>
      ),
    },
    {
      paragraph: (
        <>
          2.3 Purchases <br />
          We accept U.S.-issued credit and debit cards. By providing a payment
          method, you authorize us to charge that method for purchases and any
          recurring fees until canceled through your account settings.
        </>
      ),
    },
  ];
  const paragraph4 = [
    {
      paragraph: (
        <>
          You agree not to:
          <br />
          <ul>
            <li>
              Violate any applicable law, regulation, or third-party right.
            </li>
            <li>
              Remove copyright, trademark, or proprietary notices from any
              content.
            </li>
            <li>
              Launch automated programs (scrapers, spiders, etc.) that access
              the Services without authorization.
            </li>
            <li>
              Attempt to gain unauthorized access to any part of the Services or
              related systems.
            </li>
            <li>
              Use the Services to transmit spam or other unsolicited
              communications.
            </li>
            <li>
              Infringe the intellectual-property rights of UTIRX.com or others.
            </li>
          </ul>
          UTIRX.com may suspend or terminate your access to the Services for any
          violation of these Terms or behavior it considers disruptive or
          abusive.
        </>
      ),
    },
  ];
  const paragraph5 = [
    {
      paragraph:
        "Except as expressly provided through a Provider in a clinical encounter, all content on the Services is for informational purposes only and does not constitute medical advice. Always seek the advice of a qualified healthcare professional for questions about a medical condition.",
    },
  ];
  const paragraph6 = [
    {
      paragraph: (
        <>
          THE SERVICES ARE PROVIDED “AS IS” AND "AS AVAILABLE." UTIRX.com
          DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
          NON-INFRINGEMENT. UTIRX.com DOES NOT WARRANT THAT THE SERVICES
          WILL BE UNINTERRUPTED, SECURE, OR ERROR-FREE.
          <br />
          UTIRX.com IS NOT LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL,
          PUNITIVE, OR CONSEQUENTIAL DAMAGES ARISING FROM OR RELATED TO YOUR USE
          OF THE SERVICES. TO THE EXTENT THAT UTIRX.com IS LIABLE FOR ANY
          CLAIM, THE MAXIMUM LIABILITY IS FIFTY U.S. DOLLARS (US $50).
          <br />
          Some jurisdictions do not allow certain warranty exclusions or
          liability limitations, so they may not apply to you.
        </>
      ),
    },
  ];
  const paragraph7 = [
    {
      paragraph:
        "You agree to indemnify, defend, and hold harmless UTIRX.com, its affiliates, officers, directors, employees, and agents from any claims, damages, or expenses (including attorneys’ fees) arising out of or relating to: (i) your use of the Services; (ii) your violation of these Terms; (iii) any User Content you submit; (iv) your violation of any law or third-party right; or (v) the persistence of symptoms or development of a medical condition or complication.",
    },
  ];
  const paragraph8 = [
    {
      paragraph: (
        <>
          <ul>
            <li>
              Choice of Law. These Terms are governed by the laws of the State
              of Florida (without regard to conflict-of-law principles), except
              as governed by the FAA in Section 1.
            </li>
            <li>
              Entire Agreement. These Terms, any supplemental terms, and our
              Privacy Policy constitute the entire agreement between you and
              UTIRX.com regarding the Services.
            </li>
            <li>
              Assignment. You may not assign these Terms without our prior
              written consent. We may assign these Terms without restriction.
            </li>
            <li>
              Severability. If any provision is held invalid, the remaining
              provisions remain in force.
            </li>
            <li>
              Contact: Dr. Arash Rafiei, Email: Onlineutimeds@gmail.com
            </li>
          </ul>
          By accessing or using the Services, you acknowledge that you have
          read, understood, and agree to be bound by these Terms.
        </>
      ),
    },
  ];

  return (
    <div className="legal-page">
      <div className="content-container">
        <h2>Terms of Use for UTIRX.com</h2>
      <ul>
        <li style={{ fontWeight: "bold" }}>Contractual Relationship</li>
      </ul>
      {paragraph.map((i) => {
        return <p>{i.paragraph}</p>;
      })}
      <ol>
        <li style={{ fontWeight: "bold" }}>Arbitration Agreement</li>
      </ol>
      {paragraph2.map((i) => {
        return <p>{i.paragraph}</p>;
      })}
      <ol start={2}>
        <li style={{ fontWeight: "bold" }}>The Services</li>
      </ol>
      {paragraph3.map((i) => {
        return <p>{i.paragraph}</p>;
      })}
      <ol start={3}>
        <li style={{ fontWeight: "bold" }}>Restrictions on Use</li>
      </ol>
      {paragraph4.map((i) => {
        return <p>{i.paragraph}</p>;
      })}

      <ol start={4}>
        <li style={{ fontWeight: "bold" }}>Not Medical Advice</li>
      </ol>
      {paragraph5.map((i) => {
        return <p>{i.paragraph}</p>;
      })}
      <ol start={5}>
        <li style={{ fontWeight: "bold" }}>
          Disclaimers & Limitation of Liability
        </li>
      </ol>
      {paragraph6.map((i) => {
        return <p>{i.paragraph}</p>;
      })}
      <ol start={6}>
        <li style={{ fontWeight: "bold" }}>Indemnification</li>
      </ol>
      {paragraph7.map((i) => {
        return <p>{i.paragraph}</p>;
      })}
      <ol start={7}>
        <li style={{ fontWeight: "bold" }}> Other Provisions</li>
      </ol>
      {paragraph8.map((i) => {
        return <p>{i.paragraph}</p>;
      })}
      </div>
    </div>
  );
};

export default Terms;
